import styled from "styled-components";

export const StyledFooter = styled.div`
  padding: 23px 8% 28px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > p:last-child {
    margin-top: 17px;
    width: 100%;
  }
  
  & > p {
    width: 50%;
    display: flex;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.0875px;
    color: #586981;
  }
  
  & span {
    font-weight: 600;
    color: #ed3163;
    margin-left: auto;
  }
  
  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 0 90px 0 40px;
    max-width: 1280px;
    margin: 0 auto;
    justify-content: flex-start;
    align-items: center;
    
    & > p {
      width: fit-content;
      justify-content: flex-start;
    }
    
    & > p:first-child {
      padding: 27px 40px 27px 0;
      border-right: 1px solid rgba(58, 79, 106, 0.1);
      margin-right: 40px;
    }
    
    & > p:nth-child(2) {
      order: 3;
      margin-left: auto;
    }
    
    & > p:last-child {
      width: fit-content;
      margin-top: 0;
    }
  }
`;
